const DEFAULT_ALLOWED_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "csv",
  "png",
  "jpg",
  "jpeg",
  "txt",
];

export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024; // 10 MB

/**
 * Normalizes input extensions (handles with or without leading dots, arrays or comma-delimited strings)
 */
export const normalizeExtensions = (types) => {
  if (!types) return DEFAULT_ALLOWED_EXTENSIONS;
  if (Array.isArray(types)) {
    return types
      .map((ext) => String(ext).replace(/^\./, "").trim().toLowerCase())
      .filter(Boolean);
  }
  if (typeof types === "string") {
    return types
      .split(",")
      .map((ext) => ext.replace(/^\./, "").trim().toLowerCase())
      .filter(Boolean);
  }
  return DEFAULT_ALLOWED_EXTENSIONS;
};

/**
 * Builds the `accept` attribute string for file input (e.g. ".pdf,.doc,.docx,...")
 */
export const buildAcceptString = (extensions = DEFAULT_ALLOWED_EXTENSIONS) => {
  const list = normalizeExtensions(extensions);
  return list.map((ext) => `.${ext}`).join(",");
};

/**
 * Validates a file against allowed extensions and maximum file size
 */
export const validateAttachmentFile = (
  file,
  allowedExtensions = DEFAULT_ALLOWED_EXTENSIONS,
  maxFileSize = MAX_ATTACHMENT_SIZE
) => {
  if (!file) {
    return { isValid: false, error: "File is Required" };
  }

  const fileName = file.name || "";
  const lastDot = fileName.lastIndexOf(".");
  const extension =
    lastDot !== -1 ? fileName.slice(lastDot + 1).toLowerCase() : "";

  const validExtensions = normalizeExtensions(allowedExtensions);

  if (!extension || !validExtensions.includes(extension)) {
    const formattedList = validExtensions.map((ext) => `.${ext}`).join(", ");
    return {
      isValid: false,
      error: `Invalid file type. Only ${formattedList} files are allowed.`,
    };
  }

  if (file.size > maxFileSize) {
    const sizeInMb = Math.round(maxFileSize / (1024 * 1024));
    return {
      isValid: false,
      error: `File size exceeds ${sizeInMb} MB`,
    };
  }

  return { isValid: true, error: "" };
};

